import { AccountsListPageInitDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { AccountsListPage } from './AccountsListPage'

const AccountsListPageWrapper = () => {
  const { data, loading } = useQuery(AccountsListPageInitDocument)

  const authorized = data?.finance?._policies?.sidebarSeeFinanceAccountsSubLevelItem?.can ?? false

  if (loading) {
    return null
  }

  return (
    <ResponsivePage.Body authorized={authorized} variant="full">
      <AccountsListPage />
    </ResponsivePage.Body>
  )
}

export default AccountsListPageWrapper
